import { createContext, ReactElement } from 'react';

export interface ClientProfileSideDrawerContextShape {
  householdId: string | null;
  clientProfileId: string | null;
  isPrimary: boolean;
  isCreate: boolean;
}

export const EMPTY_CLIENT_PROFILE_SIDE_DRAWER_CONTEXT = {
  householdId: null,
  clientProfileId: null,
  isPrimary: false,
  isCreate: false,
};

export const ClientProfileSideDrawerContext =
  createContext<ClientProfileSideDrawerContextShape>(
    EMPTY_CLIENT_PROFILE_SIDE_DRAWER_CONTEXT
  );

export interface ClientProfileSideDrawerContextProviderProps
  extends Omit<ClientProfileSideDrawerContextShape, 'isCreate'> {
  children: ReactElement;
}

export function ClientProfileSideDrawerContextProvider({
  children,
  ...props
}: ClientProfileSideDrawerContextProviderProps) {
  return (
    <ClientProfileSideDrawerContext.Provider
      value={{ ...props, isCreate: !props.clientProfileId }}
    >
      {children}
    </ClientProfileSideDrawerContext.Provider>
  );
}
